import React from "react";
import "./ServicesGallery.css";

import img1 from "../../../assets/images/1@300x.png";
import img2 from "../../../assets/images/2@300x.png";
import img3 from "../../../assets/images/3@300x.png";
import img4 from "../../../assets/images/4@300x.png";

const infoItems = [
    {
        id: 1,
        title: "GESTIÓN INTEGRAL DE INVERSIONES INMOBILIARIAS",
        body: `SOLUCIONES ESTRATÉGICAS PARA MAXIMIZAR EL RENDIMIENTO DE SUS INVERSIONES.<br><br>
                <ul>
                    <li>- Análisis Estratégico del Mercado: Evaluación en profundidad de oportunidades inmobiliarias en Dubái.</li><br>
                    <li>- Asesoramiento Personalizado: Recomendaciones a medida para optimizar cada inversión.</li><br>
                    <li>- Gestión de Portafolios Diversificados: Supervisión activa para minimizar riesgos y asegurar estabilidad.</li>
                </ul>`,
        image: img1,
        element: "gestion",
    },
    {
        id: 2,
        title: "CONSULTORÍA ESTRATÉGICA JURÍDICA INMOBILIARIA",
        body: `ASESORAMIENTO LEGAL CONFIABLE PARA OPERACIONES INTERNACIONALES SEGURAS.<br><br>
                <ul>
                    <li>- Contratos de Compraventa y Arrendamiento: Redacción y revisión con expertos legales.</li><br>
                    <li>- Derecho Internacional Privado: Asesoramiento sobre regulaciones en transacciones inmobiliarias globales.</li><br>
                    <li>- Gestión de Documentación Legal: Facilitamos el proceso de compra y cumplimiento normativo.</li>
                </ul>`,
        image: img2,
        element: "consultoria",
    },
    {
        id: 3,
        title: "NETWORKING INTERNACIONAL",
        body: `CONECTANDO OPORTUNIDADES GLOBALES CON INVERSORES Y PROFESIONALES CLAVE.<br><br>
                <ul>
                    <li>- Red Global de Contactos: Facilitamos conexiones con desarrolladores y agentes inmobiliarios.</li><br>
                    <li>- Oportunidades de Negocio: Generación de alianzas estratégicas en el ámbito inmobiliario.</li><br>
                    <li>- Derecho Internacional Privado: Proceso de compra y cumplimiento normativo.</li>
                </ul>`,
        image: img3,
        element: "networking",
    },
    {
        id: 4,
        title: "SOPORTE ESTRATÉGICO PARA LA CONFORMACIÓN DE FONDOS COMUNES DE INVERSIÓN",
        body: `ESTRUCTURAS FINANCIERAS SÓLIDAS PARA PROYECTOS INMOBILIARIOS EXITOSOS.<br><br>
                <ul>
                    <li>- Conformación de Fondos Eficientes: Asesoría en la creación de fondos de inversión.</li><br>
                    <li>- Estructuras Legales y Fiscales: Coordinación con bufetes de abogados y consultoras.</li><br>
                    <li>- Gestión de Documentación: Supervisión de aspectos legales y financieros.</li><br>
                    <li>- Análisis Estratégico de Proyectos: Evaluación para maximizar rendimiento.</li>
                </ul>`,
        image: img4,
        element: "soporte",
    },
];

const ServicesGallery = () => {
  return (
      <section className="services-gallery-container">
        <div className="custom-info-list-container">
            {infoItems.map((item) => (
                <section key={item.id} className="custom-info-item" id={item.element}>
                    <div className="custom-info-image">
                        <img src={item.image} alt={item.title} />
                    </div>
                    <div className="custom-info-text">
                        <h3 className="custom-info-title">{item.title}</h3>
                        <p className="custom-info-body" dangerouslySetInnerHTML={{ __html: item.body }} />
                    </div>
                </section>
            ))}
        </div>
    </section>
  );
};

export default ServicesGallery;